import { render, staticRenderFns } from "./registerView.vue?vue&type=template&id=dc5c24e6&"
import script from "./registerView.vue?vue&type=script&lang=js&"
export * from "./registerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports